import { Avatar, Button, Container, Drawer, Hidden } from "@material-ui/core";
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { useEffect, useState } from 'react';

function AdminLogin(props) {
    const clientID="487513725146-23cg56616hug2bj6ujk7jfon27575eet.apps.googleusercontent.com"
    const [name,setName]=useState("");
    const [email,setEmail]=useState("");
    const [photo,setPhoto]=useState("");
    const [idToken,setIdToken]=useState("");
    const [isAuthenticated,setIsAuthenticated]=useState(false);
    const [showUI,setShowUI]=useState(false);
    const {authenticationHandler,security,apiDomain}=props;
  

    const googleLoginResponse = (response) => {
        if(response.profileObj){
          console.log(response.tokenObj);
            setIsAuthenticated(true);
            setName(response.profileObj.name);
            setEmail(response.profileObj.email);
            setPhoto(response.profileObj.imageUrl);
            setIdToken(response.tokenObj.id_token);
            refreshTokenSetup(response);
            authenticationHandler({isAuthenticated:true,idToken:response.tokenObj.id_token,email:response.profileObj.email});
            setShowUI(false);
        }
      }

      const refreshTokenSetup = res => {
        // Timing to renew access token
        
        let refreshTiming = (res.tokenObj.expires_in || 3600  - 5 * 60) * 1000;
        //refreshTiming = 5000;
        const refreshToken = async () => {
          const newAuthRes = await res.reloadAuthResponse();
          setIdToken(newAuthRes.id_token);
          authenticationHandler({isAuthenticated:true,idToken:newAuthRes.id_token,email:email});
          refreshTiming = (newAuthRes.expires_in || 3600  - 5 * 60) * 1000;
          //refreshTiming = 5000;
          // Setup the other timer after the first one
          setTimeout(refreshToken, refreshTiming);
        };
        // Setup first refresh timer
        setTimeout(refreshToken, refreshTiming);
      };

      const googleLogoutResponse = (response) => {
        setIsAuthenticated(false);
        setName("");
        setEmail("");
        setPhoto("");
        setIdToken("");
        authenticationHandler({isAuthenticated:false,idToken:"",email:""});
      }

      const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setShowUI(open);
      };
      const reloadSecurity = (response) => {
        let params=`/members/admin/reloadsecurity/`;
        let method="get";
        let head={"id_token":idToken};
        let body=null;
        fetch(apiDomain+params,{"headers":head,method:method,body:body})
        .then(res => res.text())
        .then(res => {
          alert("done");
        } )
        .catch((error)=>{
          alert("error"+error.message);
        });

      }
    return(
    <>
    <Avatar src={isAuthenticated?photo:"/broken-image.jpg"} onClick={toggleDrawer(true)}/>
    <GoogleLogin
        clientId={clientID}
        render={renderProps=>(
        <></>
        )}
        onSuccess={googleLoginResponse}
        onFailure={googleLoginResponse}
        isSignedIn={true}
        />
    <Drawer open={showUI} anchor="right" onClose={toggleDrawer(false)}>
    <Container>
    {isAuthenticated&&<><div style={{textAlign:"center"}}><p>{name}</p><p>{email}</p></div></>}
    {!isAuthenticated?
        <GoogleLogin
        clientId={clientID}
        onSuccess={googleLoginResponse}
        onFailure={googleLoginResponse}
        isSignedIn={true}
        />
        :
        <GoogleLogout 
        clientId={clientID}
        onLogoutSuccess={googleLogoutResponse}
        onFailure={googleLogoutResponse}
        />
    }

    
    </Container>
    {isAuthenticated&&security.admin&&<>
    <Container>
    <div style={{textAlign:"center",marginTop:20}}>
    <Button variant="outlined" onClick={reloadSecurity}>Reload Security</Button>
    </div>
    </Container>
    </>}
    </Drawer>
    </>)
}
export default AdminLogin;

